<div class="individual-header-graph">
  <div class="individual-header-graph__graph">
    <svg id="individual-header-graph" width="100%" height="100%"></svg>
  </div>
</div>
